export default "__VITE_ASSET__BmGFRSc___"